import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {logoutUser} from "../../../api/auth";

const Header = () => {

    const auth = useSelector((state) => state.auth.user);

    const dispatch = useDispatch();

    useEffect(() => {
        if (window.KTDropdown) {
            window.KTDropdown.init();
        }
    }, []);

    const onLogoutClick = (event) => {
        event.preventDefault();
        dispatch(logoutUser());
    };

    return (
        <header
            className="flex items-center transition-[height] shrink-0 bg-background h-(--header-height)"
            data-kt-sticky="true"
            data-kt-sticky-class="transition-[height] fixed z-10 top-0 left-0 right-0 backdrop-blur-md bg-background/70 border-b border-border"
            data-kt-sticky-name="header"
            data-kt-sticky-offset="200px"
            id="header"
        >
            <div
                className="kt-container-fixed flex justify-between items-center lg:gap-4"
                id="headerContainer"
            >
                <div className="flex items-center gap-2 lg:gap-5 2xl:-ml-[60px]">
                    <a href="#">
                        <img
                            className="max-h-[42px] w-full"
                            src="assets/media/app/logo-landscape.svg"
                        />
                    </a>
                </div>
                <div className="flex items-center gap-2.5">
                    {/*<button*/}
                    {/*    className="kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full"*/}
                    {/*    data-kt-drawer-toggle="#notifications_drawer"*/}
                    {/*>*/}
                    {/*    <i className="ki-filled ki-notification-status text-lg"></i>*/}
                    {/*</button>*/}
                    {/*<div*/}
                    {/*    className="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] w-[450px] top-5 bottom-5 end-5 rounded-xl border border-border"*/}
                    {/*    data-kt-drawer="true"*/}
                    {/*    data-kt-drawer-container="body"*/}
                    {/*    id="notifications_drawer"*/}
                    {/*>*/}
                    {/*    <div*/}
                    {/*        className="flex items-center justify-between gap-2.5 text-sm text-mono font-semibold px-5 py-2.5 border-b border-b-border"*/}
                    {/*        id="notifications_header"*/}
                    {/*    >*/}
                    {/*        Notifications*/}
                    {/*        <button*/}
                    {/*            className="kt-btn kt-btn-sm kt-btn-icon kt-btn-dim shrink-0"*/}
                    {/*            data-kt-drawer-dismiss="true"*/}
                    {/*        >*/}
                    {/*            <i className="ki-filled ki-cross"></i>*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="kt-tabs kt-tabs-line justify-between px-5 mb-2"*/}
                    {/*        data-kt-tabs="true"*/}
                    {/*        id="notifications_tabs"*/}
                    {/*    >*/}
                    {/*        <div className="flex items-center gap-5">*/}
                    {/*            <button*/}
                    {/*                className="kt-tab-toggle py-3 active"*/}
                    {/*                data-kt-tab-toggle="#notifications_tab_all"*/}
                    {/*            >*/}
                    {/*                All*/}
                    {/*            </button>*/}
                    {/*            <button*/}
                    {/*                className="kt-tab-toggle py-3 relative"*/}
                    {/*                data-kt-tab-toggle="#notifications_tab_inbox"*/}
                    {/*            >*/}
                    {/*                Inbox*/}
                    {/*                <span className="rounded-full bg-green-500 size-[5px] absolute top-2 rtl:start-0 end-0 transform translate-y-1/2 translate-x-full"></span>*/}
                    {/*            </button>*/}
                    {/*            <button*/}
                    {/*                className="kt-tab-toggle py-3"*/}
                    {/*                data-kt-tab-toggle="#notifications_tab_team"*/}
                    {/*            >*/}
                    {/*                Team*/}
                    {/*            </button>*/}
                    {/*            <button*/}
                    {/*                className="kt-tab-toggle py-3"*/}
                    {/*                data-kt-tab-toggle="#notifications_tab_following"*/}
                    {/*            >*/}
                    {/*                Following*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*        <div className="kt-menu" data-kt-menu="true">*/}
                    {/*            <div*/}
                    {/*                className="kt-menu-item"*/}
                    {/*                data-kt-menu-item-offset="0,10px"*/}
                    {/*                data-kt-menu-item-placement="bottom-end"*/}
                    {/*                data-kt-menu-item-placement-rtl="bottom-start"*/}
                    {/*                data-kt-menu-item-toggle="dropdown"*/}
                    {/*                data-kt-menu-item-trigger="click|lg:hover"*/}
                    {/*            >*/}
                    {/*                <button className="kt-menu-toggle kt-btn kt-btn-icon kt-btn-ghost">*/}
                    {/*                    <i className="ki-filled ki-setting-2"></i>*/}
                    {/*                </button>*/}
                    {/*                <div*/}
                    {/*                    className="kt-menu-dropdown kt-menu-default w-full max-w-[175px]"*/}
                    {/*                    data-kt-menu-dismiss="true"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-menu-item">*/}
                    {/*                        <a className="kt-menu-link" href="#">*/}
                    {/*                    <span className="kt-menu-icon">*/}
                    {/*                        <i className="ki-filled ki-document"></i>*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-menu-title">*/}
                    {/*                        View*/}
                    {/*                    </span>*/}
                    {/*                        </a>*/}
                    {/*                    </div>*/}
                    {/*                    <div*/}
                    {/*                        className="kt-menu-item"*/}
                    {/*                        data-kt-menu-item-offset="-15px, 0"*/}
                    {/*                        data-kt-menu-item-placement="right-start"*/}
                    {/*                        data-kt-menu-item-toggle="dropdown"*/}
                    {/*                        data-kt-menu-item-trigger="click|lg:hover"*/}
                    {/*                    >*/}
                    {/*                        <div className="kt-menu-link">*/}
                    {/*                    <span className="kt-menu-icon">*/}
                    {/*                        <i className="ki-filled ki-notification-status"></i>*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-menu-title">*/}
                    {/*                        Export*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-menu-arrow">*/}
                    {/*                        <i className="ki-filled ki-right text-xs rtl:transform rtl:rotate-180"></i>*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-menu-dropdown kt-menu-default w-full max-w-[175px]">*/}
                    {/*                            <div className="kt-menu-item">*/}
                    {/*                                <a*/}
                    {/*                                    className="kt-menu-link"*/}
                    {/*                                    href="html/demo2/account/home/settings-sidebar.html"*/}
                    {/*                                >*/}
                    {/*                            <span className="kt-menu-icon">*/}
                    {/*                                <i className="ki-filled ki-sms"></i>*/}
                    {/*                            </span>*/}
                    {/*                                    <span className="kt-menu-title">*/}
                    {/*                                Email*/}
                    {/*                            </span>*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="kt-menu-item">*/}
                    {/*                                <a*/}
                    {/*                                    className="kt-menu-link"*/}
                    {/*                                    href="html/demo2/account/home/settings-sidebar.html"*/}
                    {/*                                >*/}
                    {/*                            <span className="kt-menu-icon">*/}
                    {/*                                <i className="ki-filled ki-message-notify"></i>*/}
                    {/*                            </span>*/}
                    {/*                                    <span className="kt-menu-title">*/}
                    {/*                                SMS*/}
                    {/*                            </span>*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="kt-menu-item">*/}
                    {/*                                <a*/}
                    {/*                                    className="kt-menu-link"*/}
                    {/*                                    href="html/demo2/account/home/settings-sidebar.html"*/}
                    {/*                                >*/}
                    {/*                            <span className="kt-menu-icon">*/}
                    {/*                                <i className="ki-filled ki-notification-status"></i>*/}
                    {/*                            </span>*/}
                    {/*                                    <span className="kt-menu-title">*/}
                    {/*                                Push*/}
                    {/*                            </span>*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="kt-menu-item">*/}
                    {/*                        <a className="kt-menu-link" href="#">*/}
                    {/*                    <span className="kt-menu-icon">*/}
                    {/*                        <i className="ki-filled ki-pencil"></i>*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-menu-title">*/}
                    {/*                        Edit*/}
                    {/*                    </span>*/}
                    {/*                        </a>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="kt-menu-item">*/}
                    {/*                        <a className="kt-menu-link" href="#">*/}
                    {/*                    <span className="kt-menu-icon">*/}
                    {/*                        <i className="ki-filled ki-trash"></i>*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-menu-title">*/}
                    {/*                        Delete*/}
                    {/*                    </span>*/}
                    {/*                        </a>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="grow flex flex-col" id="notifications_tab_all">*/}
                    {/*        <div*/}
                    {/*            className="grow kt-scrollable-y-auto"*/}
                    {/*            data-kt-scrollable="true"*/}
                    {/*            data-kt-scrollable-dependencies="#header"*/}
                    {/*            data-kt-scrollable-max-height="auto"*/}
                    {/*            data-kt-scrollable-offset="150px"*/}
                    {/*        >*/}
                    {/*            <div className="grow flex flex-col gap-5 pt-3 pb-4 divider-y divider-border">*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-4.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Joe Lincoln*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            mentioned you in*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Latest Trends*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            topic*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        18 mins ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Web Design 2024*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex flex-col gap-2.5 p-3.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="text-sm font-semibold text-secondary-foreground mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    @Cody*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground font-medium">*/}
                    {/*                            For an expert opinion, check out*/}
                    {/*                            what Mike has to say on this*/}
                    {/*                            topic!*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="kt-input">*/}
                    {/*                                <input*/}
                    {/*                                    placeholder="Reply"*/}
                    {/*                                    type="text"*/}
                    {/*                                    value=""*/}
                    {/*                                />*/}
                    {/*                                <button className="kt-btn kt-btn-ghost kt-btn-icon size-6 -me-1.5">*/}
                    {/*                                    <i className="ki-filled ki-picture"></i>*/}
                    {/*                                </button>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-5.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Leslie Alexander*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            added new tags to*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Web Redesign 2024*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        53 mins ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        ACME*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                    <span className="kt-badge kt-badge-sm kt-badge-info kt-badge-outline">*/}
                    {/*                        Client-Request*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-badge kt-badge-sm kt-badge-warning kt-badge-outline">*/}
                    {/*                        Figma*/}
                    {/*                    </span>*/}
                    {/*                            <span className="kt-badge kt-badge-sm kt-badge-secondary kt-badge-outline">*/}
                    {/*                        Redesign*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_3"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-27.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Guy Hawkins*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            requested access to*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    AirSpace*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            project*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        14 hours ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Dev Team*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-10.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-offline size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Jane Perez*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            invites you to review a file.*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 hours ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        742kb*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <img*/}
                    {/*                                className="h-5"*/}
                    {/*                                src="assets/media/file-types/pdf.svg"*/}
                    {/*                            />*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary font-medium text-secondary-foreground text-xs me-1"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Launch_nov24.pptx*/}
                    {/*                            </a>*/}
                    {/*                            <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                        Edited 39 mins ago*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-11.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-1">*/}
                    {/*                        <div className="text-sm font-medium mb-px">*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Raymond Pawell*/}
                    {/*                            </a>*/}
                    {/*                            <span className="text-secondary-foreground">*/}
                    {/*                        posted a new article*/}
                    {/*                    </span>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-primary"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                2024 Roadmap*/}
                    {/*                            </a>*/}
                    {/*                        </div>*/}
                    {/*                        <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                    1 hour ago*/}
                    {/*                    <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                    Roadmap*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-14.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-offline size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Tyler Hero*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            wants to view your design*/}
                    {/*                            project*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 day ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Metronic Launcher mockups*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center justify-center w-[26px] h-[30px] shrink-0 bg-background rounded-sm border border-border">*/}
                    {/*                                <img*/}
                    {/*                                    className="h-5"*/}
                    {/*                                    src="assets/media/file-types/figma.svg"*/}
                    {/*                                />*/}
                    {/*                            </div>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary font-medium text-secondary-foreground text-xs me-1"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Launcher-UIkit.fig*/}
                    {/*                            </a>*/}
                    {/*                            <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                        Edited 2 mins ago*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="border-b border-b-border"></div>*/}
                    {/*        <div*/}
                    {/*            className="grid grid-cols-2 p-5 gap-2.5"*/}
                    {/*            id="notifications_all_footer"*/}
                    {/*        >*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Archive all*/}
                    {/*            </button>*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Mark all as read*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="grow flex flex-col hidden"*/}
                    {/*        id="notifications_tab_inbox"*/}
                    {/*    >*/}
                    {/*        <div*/}
                    {/*            className="grow kt-scrollable-y-auto"*/}
                    {/*            data-kt-scrollable="true"*/}
                    {/*            data-kt-scrollable-dependencies="#header"*/}
                    {/*            data-kt-scrollable-max-height="auto"*/}
                    {/*            data-kt-scrollable-offset="150px"*/}
                    {/*        >*/}
                    {/*            <div className="flex flex-col gap-5 pt-3 pb-4">*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_13"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-25.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Samuel Lee*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            requested to add user to*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    TechSynergy*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        22 hours ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Dev Team*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center flex-row justify-between gap-1.5 px-2.5 py-2 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex flex-col">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary font-medium text-mono text-xs"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Ronald Richards*/}
                    {/*                                </a>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-muted-foreground font-medium text-xs"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    ronald.richards@gmail.com*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-secondary-foreground font-medium text-xs"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Go to profile*/}
                    {/*                            </a>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_13"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_13"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex items-center grow gap-2.5 px-5">*/}
                    {/*                    <div className="flex items-center justify-center size-8 bg-green-50 rounded-full border border-green-200 dark:border-green-950">*/}
                    {/*                        <i className="ki-filled ki-check text-lg text-green-500"></i>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-1">*/}
                    {/*                <span className="text-sm font-medium text-secondary-foreground">*/}
                    {/*                    You have succesfully verified your*/}
                    {/*                    account*/}
                    {/*                </span>*/}
                    {/*                        <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                    2 days ago*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-34.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Ava Peterson*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            uploaded attachment*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        ACME*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center gap-1.5">*/}
                    {/*                                <img*/}
                    {/*                                    className="h-6"*/}
                    {/*                                    src="assets/media/file-types/xls.svg"*/}
                    {/*                                />*/}
                    {/*                                <div className="flex flex-col gap-0.5">*/}
                    {/*                                    <a*/}
                    {/*                                        className="hover:text-primary font-medium text-secondary-foreground text-xs"*/}
                    {/*                                        href="#"*/}
                    {/*                                    >*/}
                    {/*                                        Redesign-2024.xls*/}
                    {/*                                    </a>*/}
                    {/*                                    <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                                2.6 MB*/}
                    {/*                            </span>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <button className="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">*/}
                    {/*                                <svg*/}
                    {/*                                    fill="none"*/}
                    {/*                                    height="14"*/}
                    {/*                                    viewBox="0 0 14 14"*/}
                    {/*                                    width="14"*/}
                    {/*                                    xmlns="http://www.w3.org/2000/svg"*/}
                    {/*                                >*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                </svg>*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-29.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Ethan Parker*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            created a new tasks to*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Site Sculpt*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            project*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Web Designer*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none p-3.5 gap-3.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center justify-between flex-wrap gap-2.5">*/}
                    {/*                                <div className="flex flex-col gap-1">*/}
                    {/*                            <span className="font-medium text-mono text-xs">*/}
                    {/*                                Location history is erased*/}
                    {/*                                after Logging In*/}
                    {/*                            </span>*/}
                    {/*                                    <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                                Due Date: 15 May, 2024*/}
                    {/*                            </span>*/}
                    {/*                                </div>*/}
                    {/*                                <div className="flex -space-x-2">*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                        <img*/}
                    {/*                                            className="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"*/}
                    {/*                                            src="assets/media/avatars/300-3.png"*/}
                    {/*                                        />*/}
                    {/*                                    </div>*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                        <img*/}
                    {/*                                            className="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"*/}
                    {/*                                            src="assets/media/avatars/300-2.png"*/}
                    {/*                                        />*/}
                    {/*                                    </div>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="flex items-center gap-2.5">*/}
                    {/*                        <span className="kt-badge kt-badge-sm kt-badge-success kt-badge-outline">*/}
                    {/*                            Improvement*/}
                    {/*                        </span>*/}
                    {/*                                <span className="kt-badge kt-badge-sm kt-badge-destructive kt-badge-outline">*/}
                    {/*                            Bug*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_3"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-30.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Benjamin Harris*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            requested to upgrade plan*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                ></a>*/}
                    {/*                                <span className="text-secondary-foreground"></span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        4 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Marketing*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-24.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-1">*/}
                    {/*                        <div className="text-sm font-medium mb-px">*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Isaac Morgan*/}
                    {/*                            </a>*/}
                    {/*                            <span className="text-secondary-foreground">*/}
                    {/*                        mentioned you in*/}
                    {/*                    </span>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-primary"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Data Transmission*/}
                    {/*                            </a>*/}
                    {/*                            topic*/}
                    {/*                        </div>*/}
                    {/*                        <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                    6 days ago*/}
                    {/*                    <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                    Dev Team*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="border-b border-b-border"></div>*/}
                    {/*        <div*/}
                    {/*            className="grid grid-cols-2 p-5 gap-2.5"*/}
                    {/*            id="notifications_inbox_footer"*/}
                    {/*        >*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Archive all*/}
                    {/*            </button>*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Mark all as read*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="grow flex flex-col hidden"*/}
                    {/*        id="notifications_tab_team"*/}
                    {/*    >*/}
                    {/*        <div*/}
                    {/*            className="grow kt-scrollable-y-auto"*/}
                    {/*            data-kt-scrollable="true"*/}
                    {/*            data-kt-scrollable-dependencies="#header"*/}
                    {/*            data-kt-scrollable-max-height="auto"*/}
                    {/*            data-kt-scrollable-offset="150px"*/}
                    {/*        >*/}
                    {/*            <div className="flex flex-col gap-5 pt-3 pb-4">*/}
                    {/*                <div className="flex grow gap-2 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-15.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div*/}
                    {/*                        className="flex flex-col gap-3 grow"*/}
                    {/*                        id="notification_request_10"*/}
                    {/*                    >*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Nova Hawthorne*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            sent you an meeting invation*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        2 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Dev Team*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center justify-between flex-wrap gap-2.5">*/}
                    {/*                                <div className="flex items-center gap-2.5">*/}
                    {/*                                    <div className="border border-primary/10 rounded-lg">*/}
                    {/*                                        <div className="flex items-center justify-center border-b border-b-primary/10 bg-primary/10 rounded-t-lg">*/}
                    {/*                                    <span className="text-xs text-primary fw-medium p-1.5">*/}
                    {/*                                        Apr*/}
                    {/*                                    </span>*/}
                    {/*                                        </div>*/}
                    {/*                                        <div className="flex items-center justify-center size-9">*/}
                    {/*                                    <span className="fw-semibold text-mono text-md tracking-tight">*/}
                    {/*                                        12*/}
                    {/*                                    </span>*/}
                    {/*                                        </div>*/}
                    {/*                                    </div>*/}
                    {/*                                    <div className="flex flex-col gap-1.5">*/}
                    {/*                                        <a*/}
                    {/*                                            className="hover:text-primary font-medium text-secondary-foreground text-xs"*/}
                    {/*                                            href="#"*/}
                    {/*                                        >*/}
                    {/*                                            Peparation For Release*/}
                    {/*                                        </a>*/}
                    {/*                                        <span className="font-medium text-secondary-foreground text-xs">*/}
                    {/*                                    9:00 PM - 10:00 PM*/}
                    {/*                                </span>*/}
                    {/*                                    </div>*/}
                    {/*                                </div>*/}
                    {/*                                <div className="flex -space-x-2">*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                        <img*/}
                    {/*                                            className="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"*/}
                    {/*                                            src="assets/media/avatars/300-4.png"*/}
                    {/*                                        />*/}
                    {/*                                    </div>*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                        <img*/}
                    {/*                                            className="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"*/}
                    {/*                                            src="assets/media/avatars/300-1.png"*/}
                    {/*                                        />*/}
                    {/*                                    </div>*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                        <img*/}
                    {/*                                            className="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"*/}
                    {/*                                            src="assets/media/avatars/300-2.png"*/}
                    {/*                                        />*/}
                    {/*                                    </div>*/}
                    {/*                                    <div className="flex">*/}
                    {/*                                <span className="hover:z-5 relative inline-flex items-center justify-center shrink-0 rounded-full ring-1 font-semibold leading-none text-2xs size-6 text-white size-6 ring-background bg-green-500">*/}
                    {/*                                    +3*/}
                    {/*                                </span>*/}
                    {/*                                    </div>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_10"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_10"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-6.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-1">*/}
                    {/*                        <div className="text-sm font-medium mb-px">*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Adrian Vale*/}
                    {/*                            </a>*/}
                    {/*                            <span className="text-secondary-foreground">*/}
                    {/*                        change the due date of*/}
                    {/*                    </span>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-primary"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Marketing*/}
                    {/*                            </a>*/}
                    {/*                            to 13 May*/}
                    {/*                        </div>*/}
                    {/*                        <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                    2 days ago*/}
                    {/*                    <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                    Marketing*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-12.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Skylar Frost*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            uploaded 2 attachments*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Web Design*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center gap-1.5">*/}
                    {/*                                <img*/}
                    {/*                                    className="h-6"*/}
                    {/*                                    src="assets/media/file-types/word.svg"*/}
                    {/*                                />*/}
                    {/*                                <div className="flex flex-col gap-0.5">*/}
                    {/*                                    <a*/}
                    {/*                                        className="hover:text-primary font-medium text-secondary-foreground text-xs"*/}
                    {/*                                        href="#"*/}
                    {/*                                    >*/}
                    {/*                                        Landing-page.docx*/}
                    {/*                                    </a>*/}
                    {/*                                    <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                                1.9 MB*/}
                    {/*                            </span>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <button className="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">*/}
                    {/*                                <svg*/}
                    {/*                                    fill="none"*/}
                    {/*                                    height="14"*/}
                    {/*                                    viewBox="0 0 14 14"*/}
                    {/*                                    width="14"*/}
                    {/*                                    xmlns="http://www.w3.org/2000/svg"*/}
                    {/*                                >*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                </svg>*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center gap-1.5">*/}
                    {/*                                <img*/}
                    {/*                                    className="h-6"*/}
                    {/*                                    src="assets/media/file-types/svg.svg"*/}
                    {/*                                />*/}
                    {/*                                <div className="flex flex-col gap-0.5">*/}
                    {/*                                    <a*/}
                    {/*                                        className="hover:text-primary font-medium text-secondary-foreground text-xs"*/}
                    {/*                                        href="#"*/}
                    {/*                                    >*/}
                    {/*                                        New-icon.svg*/}
                    {/*                                    </a>*/}
                    {/*                                    <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                                2.3 MB*/}
                    {/*                            </span>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <button className="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">*/}
                    {/*                                <svg*/}
                    {/*                                    fill="none"*/}
                    {/*                                    height="14"*/}
                    {/*                                    viewBox="0 0 14 14"*/}
                    {/*                                    width="14"*/}
                    {/*                                    xmlns="http://www.w3.org/2000/svg"*/}
                    {/*                                >*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                    <path*/}
                    {/*                                        clip-rule="evenodd"*/}
                    {/*                                        d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"*/}
                    {/*                                        fill="#99A1B7"*/}
                    {/*                                        fill-rule="evenodd"*/}
                    {/*                                    ></path>*/}
                    {/*                                </svg>*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-21.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Selene Silverleaf*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            commented on*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    SiteSculpt*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground"></span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        4 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Manager*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex flex-col gap-2.5 p-3.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="text-sm font-semibold text-secondary-foreground mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    @Cody*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground font-medium">*/}
                    {/*                            This design is simply stunning!*/}
                    {/*                            From layout to color, it's a*/}
                    {/*                            work of art!*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="kt-input">*/}
                    {/*                                <input*/}
                    {/*                                    placeholder="Reply"*/}
                    {/*                                    type="text"*/}
                    {/*                                    value=""*/}
                    {/*                                />*/}
                    {/*                                <button className="kt-btn kt-btn-ghost kt-btn-icon size-6 -me-1.5">*/}
                    {/*                                    <i className="ki-filled ki-picture"></i>*/}
                    {/*                                </button>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_3"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-13.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Thalia Fox*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            has invited you to join*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Design Research*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground"></span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        4 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Dev Team*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="border-b border-b-border"></div>*/}
                    {/*        <div*/}
                    {/*            className="grid grid-cols-2 p-5 gap-2.5"*/}
                    {/*            id="notifications_team_footer"*/}
                    {/*        >*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Archive all*/}
                    {/*            </button>*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Mark all as read*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="grow flex flex-col hidden"*/}
                    {/*        id="notifications_tab_following"*/}
                    {/*    >*/}
                    {/*        <div*/}
                    {/*            className="grow kt-scrollable-y-auto"*/}
                    {/*            data-kt-scrollable="true"*/}
                    {/*            data-kt-scrollable-dependencies="#header"*/}
                    {/*            data-kt-scrollable-max-height="auto"*/}
                    {/*            data-kt-scrollable-offset="150px"*/}
                    {/*        >*/}
                    {/*            <div className="flex flex-col gap-5 pt-3 pb-4">*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-1.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-2.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1 mb-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Jane Perez*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            added 2 new works to*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Inspirations 2024*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        23 hours ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Craftwork Design*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex items-center gap-2.5">*/}
                    {/*                            <div className="kt-card shadow-none flex flex-col gap-3.5 bg-muted/70 w-40">*/}
                    {/*                                <div className="px-2.5 pb-2">*/}
                    {/*                                    <a*/}
                    {/*                                        className="font-medium block text-secondary-foreground hover:text-primary text-xs leading-4 mb-0.5"*/}
                    {/*                                        href="#"*/}
                    {/*                                    >*/}
                    {/*                                        Geometric Patterns*/}
                    {/*                                    </a>*/}
                    {/*                                    <div className="text-xs font-medium text-muted-foreground">*/}
                    {/*                                        Token ID:*/}
                    {/*                                        <span className="text-xs font-medium text-secondary-foreground">*/}
                    {/*                                    81023*/}
                    {/*                                </span>*/}
                    {/*                                    </div>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="kt-card shadow-none flex flex-col gap-3.5 bg-muted/70 w-40">*/}
                    {/*                                <div className="px-2.5 pb-2">*/}
                    {/*                                    <a*/}
                    {/*                                        className="font-medium block text-secondary-foreground hover:text-primary text-xs leading-4 mb-0.5"*/}
                    {/*                                        href="#"*/}
                    {/*                                    >*/}
                    {/*                                        Artistic Expressions*/}
                    {/*                                    </a>*/}
                    {/*                                    <div className="text-xs font-medium text-muted-foreground">*/}
                    {/*                                        Token ID:*/}
                    {/*                                        <span className="text-xs font-medium text-secondary-foreground">*/}
                    {/*                                    67890*/}
                    {/*                                </span>*/}
                    {/*                                    </div>*/}
                    {/*                                </div>*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_17"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-19.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-2.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1 mb-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Natalie Wood*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            wants to edit marketing project*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        1 day ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Designer*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">*/}
                    {/*                            <div className="flex items-center justify-center w-[26px] h-[30px] shrink-0 bg-white rounded-sm border border-border">*/}
                    {/*                                <img*/}
                    {/*                                    className="h-5"*/}
                    {/*                                    src="assets/media/brand-logos/jira.svg"*/}
                    {/*                                />*/}
                    {/*                            </div>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary font-medium text-secondary-foreground text-xs me-1"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                User-feedback.jira*/}
                    {/*                            </a>*/}
                    {/*                            <span className="font-medium text-muted-foreground text-xs">*/}
                    {/*                        Edited 1 hour ago*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_17"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_17"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-17.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-2.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1 mb-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Aaron Foster*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            requested to view*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 day ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Larsen Ltd*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-card shadow-none flex items-center flex-row gap-1.5 px-2.5 py-1.5 rounded-lg bg-muted/70">*/}
                    {/*                            <i className="ki-filled ki-user-tick text-green-500 text-base"></i>*/}
                    {/*                            <span className="font-medium text-green-500 text-sm">*/}
                    {/*                        You allowed Aaron to view*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-34.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-1">*/}
                    {/*                        <div className="text-sm font-medium mb-px">*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                Chloe Morgan*/}
                    {/*                            </a>*/}
                    {/*                            <span className="text-secondary-foreground">*/}
                    {/*                        posted a new article*/}
                    {/*                    </span>*/}
                    {/*                            <a*/}
                    {/*                                className="hover:text-primary text-primary"*/}
                    {/*                                href="#"*/}
                    {/*                            >*/}
                    {/*                                User Experience*/}
                    {/*                            </a>*/}
                    {/*                        </div>*/}
                    {/*                        <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                    1 day ago*/}
                    {/*                    <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                    Nexus*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div className="flex grow gap-2.5 px-5">*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-9.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-2.5 grow">*/}
                    {/*                        <div className="flex flex-col gap-1 mb-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Gabriel Bennett*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            started connect you*/}
                    {/*                        </span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        3 day ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Development*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button className="kt-btn kt-btn-sm kt-btn-outline">*/}
                    {/*                                <i className="ki-filled ki-check-circle"></i>*/}
                    {/*                                Connected*/}
                    {/*                            </button>*/}
                    {/*                            <button className="kt-btn kt-btn-mono kt-btn-sm">*/}
                    {/*                                Go to profile*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="border-b border-b-border"></div>*/}
                    {/*                <div*/}
                    {/*                    className="flex grow gap-2.5 px-5"*/}
                    {/*                    id="notification_request_3"*/}
                    {/*                >*/}
                    {/*                    <div className="kt-avatar size-8">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-13.png"*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex flex-col gap-3.5">*/}
                    {/*                        <div className="flex flex-col gap-1">*/}
                    {/*                            <div className="text-sm font-medium mb-px">*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-mono font-semibold"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Thalia Fox*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground">*/}
                    {/*                            has invited you to join*/}
                    {/*                        </span>*/}
                    {/*                                <a*/}
                    {/*                                    className="hover:text-primary text-primary"*/}
                    {/*                                    href="#"*/}
                    {/*                                >*/}
                    {/*                                    Design Research*/}
                    {/*                                </a>*/}
                    {/*                                <span className="text-secondary-foreground"></span>*/}
                    {/*                            </div>*/}
                    {/*                            <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                        4 days ago*/}
                    {/*                        <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                        Dev Team*/}
                    {/*                    </span>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="flex flex-wrap gap-2.5">*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-outline kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Decline*/}
                    {/*                            </button>*/}
                    {/*                            <button*/}
                    {/*                                className="kt-btn kt-btn-mono kt-btn-sm"*/}
                    {/*                                data-kt-dismiss="#notification_request_3"*/}
                    {/*                            >*/}
                    {/*                                Accept*/}
                    {/*                            </button>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="border-b border-b-border"></div>*/}
                    {/*        <div*/}
                    {/*            className="grid grid-cols-2 p-5 gap-2.5"*/}
                    {/*            id="notifications_following_footer"*/}
                    {/*        >*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Archive all*/}
                    {/*            </button>*/}
                    {/*            <button className="kt-btn kt-btn-outline justify-center">*/}
                    {/*                Mark all as read*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div*/}
                    {/*    className="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] w-[450px] top-5 bottom-5 end-5 rounded-xl border border-border"*/}
                    {/*    data-kt-drawer="true"*/}
                    {/*    data-kt-drawer-container="body"*/}
                    {/*    id="chat_drawer"*/}
                    {/*>*/}
                    {/*    <div>*/}
                    {/*        <div className="flex items-center justify-between gap-2.5 text-sm text-mono font-semibold px-5 py-3.5">*/}
                    {/*            Chat*/}
                    {/*            <button*/}
                    {/*                className="kt-btn kt-btn-sm kt-btn-icon kt-btn-dim shrink-0"*/}
                    {/*                data-kt-drawer-dismiss="true"*/}
                    {/*            >*/}
                    {/*                <i className="ki-filled ki-cross"></i>*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*        <div className="border-b border-b-border"></div>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="kt-scrollable-y-auto grow"*/}
                    {/*        data-kt-scrollable="true"*/}
                    {/*        data-kt-scrollable-dependencies="#header"*/}
                    {/*        data-kt-scrollable-max-height="auto"*/}
                    {/*        data-kt-scrollable-offset="230px"*/}
                    {/*    >*/}
                    {/*        <div className="flex flex-col gap-5 py-5">*/}
                    {/*            <div className="flex items-end gap-3.5 px-5">*/}
                    {/*                <img*/}
                    {/*                    alt=""*/}
                    {/*                    className="rounded-full size-9"*/}
                    {/*                    src="assets/media/avatars/300-5.png"*/}
                    {/*                />*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">*/}
                    {/*                        Next week we are closing the project. Do You*/}
                    {/*                        have questions?*/}
                    {/*                    </div>*/}
                    {/*                    <span className="text-xs font-medium text-muted-foreground">*/}
                    {/*                14:04*/}
                    {/*            </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end justify-end gap-3.5 px-5">*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">*/}
                    {/*                        <p className="text-2sm font-medium text-primary-foreground">*/}
                    {/*                            This is excellent news!*/}
                    {/*                        </p>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex items-center justify-end gap-2 relative">*/}
                    {/*                <span className="text-xs font-medium text-secondary-foreground">*/}
                    {/*                    14:08*/}
                    {/*                </span>*/}
                    {/*                        <i className="ki-filled ki-double-check text-lg absolute text-green-500"></i>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="relative shrink-0">*/}
                    {/*                    <div className="kt-avatar size-9">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-2.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end gap-3.5 px-5">*/}
                    {/*                <img*/}
                    {/*                    alt=""*/}
                    {/*                    className="rounded-full size-9"*/}
                    {/*                    src="assets/media/avatars/300-4.png"*/}
                    {/*                />*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">*/}
                    {/*                        I have checked the features, can not wait to*/}
                    {/*                        demo them!*/}
                    {/*                    </div>*/}
                    {/*                    <span className="text-xs font-medium text-muted-foreground">*/}
                    {/*                14:26*/}
                    {/*            </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end gap-3.5 px-5">*/}
                    {/*                <img*/}
                    {/*                    alt=""*/}
                    {/*                    className="rounded-full size-9"*/}
                    {/*                    src="assets/media/avatars/300-1.png"*/}
                    {/*                />*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">*/}
                    {/*                        I have looked over the rollout plan, and*/}
                    {/*                        everything seems spot on.*/}
                    {/*                    </div>*/}
                    {/*                    <span className="text-xs font-medium text-muted-foreground">*/}
                    {/*                15:09*/}
                    {/*            </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end justify-end gap-3.5 px-5">*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">*/}
                    {/*                        <p className="text-2sm font-medium text-primary-foreground">*/}
                    {/*                            Haven't seen the build yet, I'll look*/}
                    {/*                            now.*/}
                    {/*                        </p>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex items-center justify-end gap-2 relative">*/}
                    {/*                <span className="text-xs font-medium text-secondary-foreground">*/}
                    {/*                    15:52*/}
                    {/*                </span>*/}
                    {/*                        <i className="ki-filled ki-double-check text-lg absolute text-muted-foreground"></i>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="relative shrink-0">*/}
                    {/*                    <div className="kt-avatar size-9">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-2.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end justify-end gap-3.5 px-5">*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">*/}
                    {/*                        <p className="text-2sm font-medium text-primary-foreground">*/}
                    {/*                            Checking the build now*/}
                    {/*                        </p>*/}
                    {/*                    </div>*/}
                    {/*                    <div className="flex items-center justify-end gap-2 relative">*/}
                    {/*                <span className="text-xs font-medium text-secondary-foreground">*/}
                    {/*                    15:52*/}
                    {/*                </span>*/}
                    {/*                        <i className="ki-filled ki-double-check text-lg absolute text-muted-foreground"></i>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                <div className="relative shrink-0">*/}
                    {/*                    <div className="kt-avatar size-9">*/}
                    {/*                        <div className="kt-avatar-image">*/}
                    {/*                            <img*/}
                    {/*                                alt="avatar"*/}
                    {/*                                src="assets/media/avatars/300-2.png"*/}
                    {/*                            ></img>*/}
                    {/*                        </div>*/}
                    {/*                        <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                            <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-end gap-3.5 px-5">*/}
                    {/*                <img*/}
                    {/*                    alt=""*/}
                    {/*                    className="rounded-full size-9"*/}
                    {/*                    src="assets/media/avatars/300-4.png"*/}
                    {/*                />*/}
                    {/*                <div className="flex flex-col gap-1.5">*/}
                    {/*                    <div className="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">*/}
                    {/*                        Tomorrow, I will send the link for the*/}
                    {/*                        meeting*/}
                    {/*                    </div>*/}
                    {/*                    <span className="text-xs font-medium text-muted-foreground">*/}
                    {/*                17:40*/}
                    {/*            </span>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="mb-2.5">*/}
                    {/*        <div*/}
                    {/*            className="flex grow gap-2 px-5 py-3.5 bg-accent/60 mb-2.5 border-y border-border"*/}
                    {/*            id="join_request"*/}
                    {/*        >*/}
                    {/*            <div className="kt-avatar size-9">*/}
                    {/*                <div className="kt-avatar-image">*/}
                    {/*                    <img*/}
                    {/*                        alt="avatar"*/}
                    {/*                        src="assets/media/avatars/300-14.png"*/}
                    {/*                    ></img>*/}
                    {/*                </div>*/}
                    {/*                <div className="kt-avatar-indicator -end-2 -bottom-2">*/}
                    {/*                    <div className="kt-avatar-status kt-avatar-status-online size-2.5"></div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*            <div className="flex items-center justify-between gap-3 grow">*/}
                    {/*                <div className="flex flex-col">*/}
                    {/*                    <div className="text-sm mb-px">*/}
                    {/*                        <a*/}
                    {/*                            className="hover:text-primary font-semibold text-mono"*/}
                    {/*                            href="#"*/}
                    {/*                        >*/}
                    {/*                            Jane Perez*/}
                    {/*                        </a>*/}
                    {/*                        <span className="text-secondary-foreground">*/}
                    {/*                    wants to join chat*/}
                    {/*                </span>*/}
                    {/*                    </div>*/}
                    {/*                    <span className="flex items-center text-xs font-medium text-muted-foreground">*/}
                    {/*                1 day ago*/}
                    {/*                <span className="rounded-full size-1 bg-mono/30 mx-1.5"></span>*/}
                    {/*                Design Team*/}
                    {/*            </span>*/}
                    {/*                </div>*/}
                    {/*                <div className="flex gap-2.5">*/}
                    {/*                    <button*/}
                    {/*                        className="kt-btn kt-btn-sm kt-btn-outline kt-btn-sm"*/}
                    {/*                        data-kt-dismiss="#join_request"*/}
                    {/*                    >*/}
                    {/*                        Decline*/}
                    {/*                    </button>*/}
                    {/*                    <button className="kt-btn kt-btn-sm kt-btn-mono kt-btn-sm">*/}
                    {/*                        Accept*/}
                    {/*                    </button>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div
                        data-kt-dropdown="true"
                        data-kt-dropdown-offset="10px, 10px"
                        data-kt-dropdown-offset-rtl="-20px, 10px"
                        data-kt-dropdown-placement="bottom-end"
                        data-kt-dropdown-placement-rtl="bottom-start"
                        data-kt-dropdown-trigger="click"
                    >
                        <div
                            className="cursor-pointer shrink-0"
                            data-kt-dropdown-toggle="true"
                        >
                            <img
                                alt=""
                                className="size-9 rounded-full border-2 border-input shrink-0"
                                src={auth.user.meta?.logo ? auth.user.meta?.logo : "assets/media/avatars/blank.png"}
                            ></img>
                        </div>
                        <div
                            className="kt-dropdown-menu w-[250px]"
                            data-kt-dropdown-menu="true"
                        >
                            <div className="flex items-center justify-between px-2.5 py-1.5 gap-1.5">
                                <div className="flex items-center gap-2">
                                    <img
                                        alt=""
                                        className="size-9 shrink-0 rounded-full border-2 border-green-500"
                                        src={auth.user.meta?.logo ? auth.user.meta?.logo : "assets/media/avatars/blank.png"}
                                    />
                                    <div className="flex flex-col gap-1.5">
                                <span className="text-sm text-foreground font-semibold leading-none">
                                    {auth.user.name}
                                </span>
                                        <a
                                            className="text-xs text-secondary-foreground hover:text-primary font-medium leading-none"
                                            href="#"
                                        >
                                            {auth.user.email}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="px-2.5 pt-1.5 mb-2.5 flex flex-col gap-3.5">
                                <div className="flex items-center gap-2 justify-between">
                            <span className="flex items-center gap-2">
                                <i className="ki-filled ki-moon text-base text-muted-foreground"></i>
                                <span className="font-medium text-2sm">
                                    Dark Mode
                                </span>
                            </span>
                                    <input
                                        className="kt-switch"
                                        data-kt-theme-switch-state="dark"
                                        data-kt-theme-switch-toggle="true"
                                        name="check"
                                        type="checkbox"
                                        value="1"
                                    />
                                </div>
                                <a
                                    className="kt-btn kt-btn-outline justify-center w-full"
                                    href="javascript:void(0)"
                                    onClick={onLogoutClick.bind()}
                                >
                                    Log out
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>);
}

export default Header;
